import React, { useEffect, useState } from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import RebateSupplierRow from '../../components/rebatesupplier/RebateSupplierRow';
import { useDispatch, useSelector } from 'react-redux';
import { purchaseRebateSupplierItemsFetchData } from '../../actions/supplierActions';
import NoRowExistsRow from '../../components/common/noRowExistsRow';
import { BeatLoader } from 'react-spinners';

const SupplierRebatePage = () => {
  const dispatch = useDispatch();
  const purchaseRebateSupplier = useSelector(
    (state) => state.purchaseRebateSupplierItems ?? [],
  );
  const isLoading = useSelector(
    (state) => state.purchaseRebateSupplierItemsIsLoading ?? true,
  );

  const [emptyRowString] = useState('No Data Found');

  useEffect(() => {
    dispatch(purchaseRebateSupplierItemsFetchData());
  }, [dispatch]);

  const prsupplierRows =
    purchaseRebateSupplier && purchaseRebateSupplier.length > 0 ? (
      purchaseRebateSupplier.map((prsupplier) => (
        <div className='panel panel-default' key={prsupplier.id}>
          <RebateSupplierRow prsuppliers={prsupplier} />
        </div>
      ))
    ) : !isLoading ? (
      <NoRowExistsRow emptyRowText={emptyRowString} />
    ) : (
      <></>
    );

  return (
    <div>
      <h4>Manage Purchase Rebate Suppliers</h4>
      <Link to='/supplier-rebate-search'>
        <Button className='btn btn-success mb-3 mt-3'>
          <FontAwesomeIcon icon={faPlus} /> Add New
        </Button>
      </Link>
      <Container fluid>
        <Row>
          <Col md='1' className='column-header white-border'>
            Supplier ID
          </Col>
          <Col md='5' className='column-header white-border'>
            Supplier Name
          </Col>
          <Col md='3' className='column-header white-border'>
            Date Added
          </Col>
          <Col md='3' className='column-header white-border'>
            Actions
          </Col>
        </Row>
        {prsupplierRows}
        <Row>
          <Col>
            <BeatLoader color={'#004C5F'} loading={isLoading} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SupplierRebatePage;
